'use client';

import React from 'react';
import { Button } from '@shared/components/shadcn/button';
import { ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ContinueButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  loadingText?: string;
  text?: string;
  className?: string;
  showArrow?: boolean;
  fullWidth?: boolean;
}

export const ContinueButton: React.FC<ContinueButtonProps> = ({
  onClick,
  disabled = false,
  loading = false,
  loadingText = 'Processing...',
  text = 'Continue',
  className,
  showArrow = true,
  fullWidth = false,
}) => {
  return (
    <div className={cn("text-center", className)}>
      <Button
        type="button"
        onClick={onClick}
        disabled={disabled || loading}
        size="default"
        className={cn(
          "min-w-[200px] sm:min-w-[280px] h-10 sm:h-12 text-sm sm:text-lg font-semibold bg-[#2A6354] hover:bg-[#1f4a3f] text-white shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all",
          fullWidth ? "w-full" : "w-full sm:w-auto"
        )}
      >
        {loading ? (
          <div className="flex items-center gap-2">
            <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {loadingText}
          </div>
        ) : (
          <span className="flex items-center gap-2">
            {text}
            {showArrow && <ArrowRight className="w-5 h-5" />}
          </span>
        )}
      </Button>
    </div>
  );
};